<template>
  <app-modal class="purchase">
    {{$router.params}}
    <app-modal-default @close="close">
      <template v-slot:header>
        {{$ml.get('Buy')}}
      </template>

      <template v-slot:content>
        <div class="content">

          <form @submit="submit">
            <div class="column">
              <div class="group">
                <h3>{{$ml.get('1) Purchase for')}}:</h3>
                <div class="select-type">
                  <p @click="changeType(false)" :class="{active: !byFields}">
                  {{ $ml.get('Based on hectares') }}
                  </p>
                  <p @click="changeType(true)" :class="{active: byFields}">
                    {{ $ml.get('Based on fields') }}
                  </p>
                </div>
              </div>

              <div class="group">
                <h3>{{$ml.get('2) Details')}}:</h3>
                <p v-if="!byFields">
                  <app-text-input
                    :required="true"
                    :disabled="byFields"
                    :hint="$ml.get('hectares')"
                    type="number"
                    min="1"
                    v-model="hectares"
                  />
                </p>
                <div v-else class="farms">
                  <div
                    class="farm"
                    v-for="farm in farms"
                    v-if="farm.fields.length"
                  >
                    <b>{{farm.name}}:</b>
                    <div class="fields">
                      <div class="field" v-for="field in farm.fields" v-if="!field.connectedToVultus && field.shape == 'polygon'">
                        <app-checkbox
                          :label="`${field.name} (${ (parseFloat(field.area) * form.price * form.months).toFixed(2) } GBP)`"
                          @input="recalculateHectares"
                          v-model="fieldIDs.find(x => x.id == field.id).active"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="group">
                <h3>{{$ml.get('3) Available crops')}}:</h3>
                <p>General, corn, potato, sugarcane, soybeans, rapeseed, cotton, wheat, barley</p>
              </div>
            </div>


            <div class="column">
              <div class="group">
                <h3>{{$ml.get('4) Price')}}:</h3>
                <div class="table">
                  <div class="row head">
                    <div class="col">{{ $ml.get('Area') }}</div>
                    <div class="col">{{ $ml.get('Months') }}</div>
                    <div class="col">{{ $ml.get('Price per hectare') }}</div>
                  </div>
                  <div class="row">
                    <div class="col">{{hectares}} {{$ml.get('hectares')}}</div>
                    <div class="col">{{form.months}}</div>
                    <div class="col">{{form.price}} GBP / ha</div>
                  </div>
                  <div class="row total">
                    <div class="col">
                      {{ $ml.get('Total') }}:
                    </div>
                    <div class="col"></div>
                    <div class="col">
                      <b> {{totalPrice}} GBP</b>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <PaymentMethod v-model="form.pm"/>
              </div>

              <div class="group">
                <app-btn type="submit" @click="submit" :loading="loading">{{$ml.get('Buy')}}</app-btn>
              </div>
            </div>

          </form>
        </div>
      </template>

    </app-modal-default>
  </app-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { SatelliteAPI } from '@/api'
import PaymentMethod from '@/components/common/PaymentMethod';

export default {
  data() {
    return {
      byFields: true,
      fieldIDs: [],
      hectares: 0,
      loading: false,
      form: {
        hectares: 0,
        type: 0,
        price: 0.99,
        months: 3,
        crops: [],
        name: '',
        address: '',
        pm: null,
      },
    }
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      this.loading = true;

      // console.log(this.hectares, this.form.hectares);

      if(this.form.pm) {
        var pm = await this.$env.stripe.createPaymentMethod(this.form.pm)
          .then(res => res.paymentMethod)
          .catch(err => { this.loading = false; });
      } else {
        var pm = null;
      }

      const pi = await SatelliteAPI
        .buy(this.hectares, pm ? pm.id : null)
        .then(res => res.data)
        .catch(err => {
          this.loading = false;
        });

      if(pi.status !== 'succeeded') {
        if(pi.status === 'requires_action') {
          const result = await this.$env.stripe.confirmCardPayment(pi.secret);
          if(result.error) {
            this.loading = false;
          }
        } else {
          throw new PaymentError('initial-payment-failed');
        }
      } else {
        this.$store.dispatch('user/updateData').then(res => {
          this.loading = false;
          history.back();
        });
      }
    },
    close() {
      history.back();
    },
    recalculateHectares() {
      let summary = 0;
      this.fieldIDs.forEach( (el) => {
        if(el.active) {
          summary += parseFloat(el.area);
        }
      })
      this.hectares = summary.toFixed(2);
    },
    changeType(bool) {
      this.hectares = 0;
      this.byFields = bool;
    },
  },
  created() {
    // console.log(this.$route.query.id);
    // if(this.field) {
      // this.byFields = true;
      // this.hectares = Math.ceil(this.field.area);
      // this.hectares = this.field.area;
    // } else {
    //   this.hectares = 0;
    // }
    this.fieldIDs = this.fields.map((el) => {
      console.log(el.coordinates);
      return {
        id: el.id,
        active: false,
        area: el.area,
      }
    });
    // console.log(this.fieldIDs);
    // console.log('as');
  },
  computed: {
    ...mapGetters({
      // field: 'satellite/fieldInfo',
      fields: 'farms/fields',
      farms: 'farms/data',
    }),
    totalPrice() {
      return (this.hectares * this.form.price * this.form.months).toFixed(2);
    },
    // byFields: {
    //   get() {
    //     if(this.field) {
    //       return true;
    //     }
    //     return false;
    //   },
    //   set(value) {
    //     return value;
    //   },
    // },
  },
  components: {
    PaymentMethod,
  }
}
</script>

<style lang="scss" scoped>
.purchase {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  .content {
    h1 {
      margin-top: 0;
    }
    form {
      width: 800px;
      display: flex;
      .column {
        width: 400px;
        padding: 0 16px;
      }
      .group {
        margin-bottom: 24px;
        h3 {
          margin-top: 0;
          margin-bottom: 16px;
        }
        .tips {
          font-size: 14px;
          line-height: 16px;
          .helper-question-mark {
            margin-right: 4px;
            display: inline-block;
            margin-left: 0;
          }
        }
        .select-type {
          display: flex;
          margin-right: -8px;
          margin-left: -8px;
          p {
            flex-basis: calc(50% - 16px);
            margin: 0 8px;
            padding: 12px 8px;
            box-sizing: border-box;
            border-radius: 5px;
            background-color: #fff;
            border: 1px solid $mainGreen;
            color: $mainGreen;
            transition: 0.3s;
            cursor: pointer;
            text-align: center;
            &.active {
              color: #fff;
              background-color: $mainGreen;
            }
          }
        }
        .table {
          .row {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 8px;
            margin-bottom: 8px;
            border-bottom: 1px solid #e0e0e0;
            .col {
              // flex-grow: 1;
              flex-basis: 33.33%;
              padding-right: 8px;
              box-sizing: border-box;
            }
            &.head {
              color: #8B8D91;
              font-size: 14px;
            }
            &:last-child {
              border-bottom: none;
            }
          }
          .total {
            padding-top: 12px;
            // display: flex;
            // flex-direction: row;
            // justify-content: flex-end;
            b {
              // padding-left: 8px;
            }
          }
        }
        .farms {
          max-height: 300px;
          overflow-y: scroll;
          .farm {
            b {

            }
            .fields {
              padding-left: 4px;
              .field {
                .v-check {
                  &::v-deep {
                    label {
                      padding: 6px 0;
                      height: auto;
                      span {
                        font-size: 16px;
                      }
                    }
                  }
                }
              }
            }


          }
        }
      }
    }
  }

  .card {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    > div {
      margin-bottom: 16px;
    }
  }
}
</style>
